<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="bp('deleteTitle')"
    :center="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    body-class="hidden"
    :z-index="16000020"
    qaid="deleteDialog.headerText"
    :close-dialog-tooltip="bp('closeDialogToolTip')"
    @close="closeDialog"
  >
    <template slot="footer">
      <div class="buttons buttons--center">
        <trek-button alert qaid="deleteDialog.confirmButton" @click.stop="deleteContainer">
          <span v-html="bp('deleteConfirm')"></span>
        </trek-button>
        <trek-button secondary qaid="deleteDialog.cancelButton" @click.stop="closeDialog">
          <span v-html="bp('cancel')"></span>
        </trek-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import get from 'lodash/get';
import {mapActions, mapMutations, mapState} from 'vuex';
import TrekButton from '@/components/TrekButton';
import ElDialog from '@/components/Dialog';

export default {
  components: {ElDialog, TrekButton},

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dialogVisible: false,
    };
  },

  computed: {
    ...mapState('backend', ['containerToDelete']),
  },

  watch: {
    containerToDelete(value) {
      if (value && value.length) this.dialogVisible = true;
      else this.dialogVisible = false;
    },
  },

  methods: {
    deleteContainer() {
      this.setUseToastInterceptor(true);

      axios
        .patch('/containers', {
          containerType: this.containerToDelete,
        })
        .then((response) => {
          // If the response was not successful then throw the error (warning toast below)
          if (get(response, 'data.meta.feedback.type') !== 'success') {
            throw new Error('Unsuccessful response');
          }
        })
        .catch(() => {
          this.$notify({
            type: 'warning',
            message: this.bp('deleteTryAgain'),
          });
        })
        .finally(() => {
          this.fetchCart();
          this.fetchMiniCart();
          this.setUseToastInterceptor(false);
        });

      this.closeDialog();
    },

    closeDialog() {
      this.setContainerToDelete(null);
    },

    ...mapActions('cart', ['fetchCart']),
    ...mapActions('miniCart', ['fetchMiniCart']),
    ...mapMutations('global', ['setUseToastInterceptor']),
    ...mapMutations('backend', ['setContainerToDelete']),
  },
};
</script>
